/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * FastMile API
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  CreateCheckoutSessionRequestDto,
  CreateCheckoutSessionResponseDtoApiResponse,
  CreatePortalSessionRequestDto,
  CreatePortalSessionResponseDtoApiResponse,
  CreateSubscriptionRequestDto,
  ProblemDetails,
  SubscriptionDtoApiResponse,
} from '../../models/generated'

import { fastmileInstance } from '../../fastmileInstance'

export const getApiSubscriptionCurrent = (signal?: AbortSignal) => {
  return fastmileInstance<SubscriptionDtoApiResponse>({
    url: '/api/Subscription/current',
    method: 'GET',
    signal,
  })
}

export const getGetApiSubscriptionCurrentQueryKey = () => {
  return ['/api/Subscription/current'] as const
}

export const getGetApiSubscriptionCurrentQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiSubscriptionCurrent>>,
  TError = ProblemDetails,
>(options?: {
    query?: Partial<
    UseQueryOptions<
    Awaited<ReturnType<typeof getApiSubscriptionCurrent>>,
    TError,
    TData
    >
    >;
  }) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetApiSubscriptionCurrentQueryKey()

  const queryFn: QueryFunction<
  Awaited<ReturnType<typeof getApiSubscriptionCurrent>>
  > = ({ signal }) => getApiSubscriptionCurrent(signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
  Awaited<ReturnType<typeof getApiSubscriptionCurrent>>,
  TError,
  TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiSubscriptionCurrentQueryResult = NonNullable<
Awaited<ReturnType<typeof getApiSubscriptionCurrent>>
>
export type GetApiSubscriptionCurrentQueryError = ProblemDetails

export function useGetApiSubscriptionCurrent<
  TData = Awaited<ReturnType<typeof getApiSubscriptionCurrent>>,
  TError = ProblemDetails,
>(options: {
  query: Partial<
  UseQueryOptions<
  Awaited<ReturnType<typeof getApiSubscriptionCurrent>>,
  TError,
  TData
  >
  > &
  Pick<
  DefinedInitialDataOptions<
  Awaited<ReturnType<typeof getApiSubscriptionCurrent>>,
  TError,
  Awaited<ReturnType<typeof getApiSubscriptionCurrent>>
  >,
  'initialData'
  >;
}): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}
export function useGetApiSubscriptionCurrent<
  TData = Awaited<ReturnType<typeof getApiSubscriptionCurrent>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
  UseQueryOptions<
  Awaited<ReturnType<typeof getApiSubscriptionCurrent>>,
  TError,
  TData
  >
  > &
  Pick<
  UndefinedInitialDataOptions<
  Awaited<ReturnType<typeof getApiSubscriptionCurrent>>,
  TError,
  Awaited<ReturnType<typeof getApiSubscriptionCurrent>>
  >,
  'initialData'
  >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}
export function useGetApiSubscriptionCurrent<
  TData = Awaited<ReturnType<typeof getApiSubscriptionCurrent>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
  UseQueryOptions<
  Awaited<ReturnType<typeof getApiSubscriptionCurrent>>,
  TError,
  TData
  >
  >;
}): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
}

export function useGetApiSubscriptionCurrent<
  TData = Awaited<ReturnType<typeof getApiSubscriptionCurrent>>,
  TError = ProblemDetails,
>(options?: {
  query?: Partial<
  UseQueryOptions<
  Awaited<ReturnType<typeof getApiSubscriptionCurrent>>,
  TError,
  TData
  >
  >;
}): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  } {
  const queryOptions = getGetApiSubscriptionCurrentQueryOptions(options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const postApiSubscription = (
  createSubscriptionRequestDto: CreateSubscriptionRequestDto,
  signal?: AbortSignal,
) => {
  return fastmileInstance<SubscriptionDtoApiResponse>({
    url: '/api/Subscription',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createSubscriptionRequestDto,
    signal,
  })
}

export const getPostApiSubscriptionMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSubscription>>,
    TError,
    { data: CreateSubscriptionRequestDto },
    TContext
    >;
  }): UseMutationOptions<
  Awaited<ReturnType<typeof postApiSubscription>>,
  TError,
  { data: CreateSubscriptionRequestDto },
  TContext
  > => {
  const mutationKey = ['postApiSubscription']
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
  Awaited<ReturnType<typeof postApiSubscription>>,
  { data: CreateSubscriptionRequestDto }
  > = (props) => {
    const { data } = props ?? {}

    return postApiSubscription(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApiSubscriptionMutationResult = NonNullable<
Awaited<ReturnType<typeof postApiSubscription>>
>
export type PostApiSubscriptionMutationBody = CreateSubscriptionRequestDto
export type PostApiSubscriptionMutationError = ProblemDetails

export const usePostApiSubscription = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSubscription>>,
    TError,
    { data: CreateSubscriptionRequestDto },
    TContext
    >;
  }): UseMutationResult<
  Awaited<ReturnType<typeof postApiSubscription>>,
  TError,
  { data: CreateSubscriptionRequestDto },
  TContext
  > => {
  const mutationOptions = getPostApiSubscriptionMutationOptions(options)

  return useMutation(mutationOptions)
}

export const deleteApiSubscription = () => {
  return fastmileInstance<SubscriptionDtoApiResponse>({
    url: '/api/Subscription',
    method: 'DELETE',
  })
}

export const getDeleteApiSubscriptionMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiSubscription>>,
    TError,
    void,
    TContext
    >;
  }): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiSubscription>>,
  TError,
  void,
  TContext
  > => {
  const mutationKey = ['deleteApiSubscription']
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
  Awaited<ReturnType<typeof deleteApiSubscription>>,
  void
  > = () => {
    return deleteApiSubscription()
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteApiSubscriptionMutationResult = NonNullable<
Awaited<ReturnType<typeof deleteApiSubscription>>
>

export type DeleteApiSubscriptionMutationError = ProblemDetails

export const useDeleteApiSubscription = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiSubscription>>,
    TError,
    void,
    TContext
    >;
  }): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiSubscription>>,
  TError,
  void,
  TContext
  > => {
  const mutationOptions = getDeleteApiSubscriptionMutationOptions(options)

  return useMutation(mutationOptions)
}

export const postApiSubscriptionCreateCheckoutSession = (
  createCheckoutSessionRequestDto: CreateCheckoutSessionRequestDto,
  signal?: AbortSignal,
) => {
  return fastmileInstance<CreateCheckoutSessionResponseDtoApiResponse>({
    url: '/api/Subscription/create-checkout-session',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createCheckoutSessionRequestDto,
    signal,
  })
}

export const getPostApiSubscriptionCreateCheckoutSessionMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSubscriptionCreateCheckoutSession>>,
    TError,
    { data: CreateCheckoutSessionRequestDto },
    TContext
    >;
  }): UseMutationOptions<
  Awaited<ReturnType<typeof postApiSubscriptionCreateCheckoutSession>>,
  TError,
  { data: CreateCheckoutSessionRequestDto },
  TContext
  > => {
  const mutationKey = ['postApiSubscriptionCreateCheckoutSession']
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
  Awaited<ReturnType<typeof postApiSubscriptionCreateCheckoutSession>>,
  { data: CreateCheckoutSessionRequestDto }
  > = (props) => {
    const { data } = props ?? {}

    return postApiSubscriptionCreateCheckoutSession(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApiSubscriptionCreateCheckoutSessionMutationResult =
  NonNullable<
  Awaited<ReturnType<typeof postApiSubscriptionCreateCheckoutSession>>
  >
export type PostApiSubscriptionCreateCheckoutSessionMutationBody =
  CreateCheckoutSessionRequestDto
export type PostApiSubscriptionCreateCheckoutSessionMutationError =
  ProblemDetails

export const usePostApiSubscriptionCreateCheckoutSession = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSubscriptionCreateCheckoutSession>>,
    TError,
    { data: CreateCheckoutSessionRequestDto },
    TContext
    >;
  }): UseMutationResult<
  Awaited<ReturnType<typeof postApiSubscriptionCreateCheckoutSession>>,
  TError,
  { data: CreateCheckoutSessionRequestDto },
  TContext
  > => {
  const mutationOptions =
    getPostApiSubscriptionCreateCheckoutSessionMutationOptions(options)

  return useMutation(mutationOptions)
}

export const postApiSubscriptionCreatePortalSession = (
  createPortalSessionRequestDto: CreatePortalSessionRequestDto,
  signal?: AbortSignal,
) => {
  return fastmileInstance<CreatePortalSessionResponseDtoApiResponse>({
    url: '/api/Subscription/create-portal-session',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createPortalSessionRequestDto,
    signal,
  })
}

export const getPostApiSubscriptionCreatePortalSessionMutationOptions = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSubscriptionCreatePortalSession>>,
    TError,
    { data: CreatePortalSessionRequestDto },
    TContext
    >;
  }): UseMutationOptions<
  Awaited<ReturnType<typeof postApiSubscriptionCreatePortalSession>>,
  TError,
  { data: CreatePortalSessionRequestDto },
  TContext
  > => {
  const mutationKey = ['postApiSubscriptionCreatePortalSession']
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
  Awaited<ReturnType<typeof postApiSubscriptionCreatePortalSession>>,
  { data: CreatePortalSessionRequestDto }
  > = (props) => {
    const { data } = props ?? {}

    return postApiSubscriptionCreatePortalSession(data)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostApiSubscriptionCreatePortalSessionMutationResult = NonNullable<
Awaited<ReturnType<typeof postApiSubscriptionCreatePortalSession>>
>
export type PostApiSubscriptionCreatePortalSessionMutationBody =
  CreatePortalSessionRequestDto
export type PostApiSubscriptionCreatePortalSessionMutationError =
  ProblemDetails

export const usePostApiSubscriptionCreatePortalSession = <
  TError = ProblemDetails,
  TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSubscriptionCreatePortalSession>>,
    TError,
    { data: CreatePortalSessionRequestDto },
    TContext
    >;
  }): UseMutationResult<
  Awaited<ReturnType<typeof postApiSubscriptionCreatePortalSession>>,
  TError,
  { data: CreatePortalSessionRequestDto },
  TContext
  > => {
  const mutationOptions =
    getPostApiSubscriptionCreatePortalSessionMutationOptions(options)

  return useMutation(mutationOptions)
}
